var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
const VisuallyHiddenElement = styled.span `
  ${({ theme: { screenReader } }) => `
    ${screenReader.srOnlyInline}
  `}
`;
const ScreenReaderOnly = React.forwardRef((_a, ref) => {
    var { as = 'span', children, displayBlock } = _a, others = __rest(_a, ["as", "children", "displayBlock"]);
    if (displayBlock)
        return (React.createElement("div", { "data-testID": "mui-sro-container" },
            React.createElement(VisuallyHiddenElement, Object.assign({ ref: ref, as: as }, others), children)));
    return (React.createElement(VisuallyHiddenElement, Object.assign({ ref: ref, as: as }, others), children));
});
export { ScreenReaderOnly };
//# sourceMappingURL=ScreenReaderOnly.js.map